import { render, staticRenderFns } from "./CardTextAlignment.vue?vue&type=template&id=3376dcbf"
import script from "./CardTextAlignment.vue?vue&type=script&lang=js"
export * from "./CardTextAlignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports